<template>

<div v-if="hints.length || teaser" class="hints">

	<div class="hints-head">Hints</div>

	<div class="hints-list">

		<transition-group name="hint" tag="div" class="hints-revealed">
			<div
				v-for="(hint, index) in hints"
				:key="index + '-' + hint.label"
				class="hint-tile"
			>
				<span class="hint-label">{{ hint.label }}</span>
				<span class="hint-value">{{ hint.value }}</span>
			</div>
		</transition-group>

		<!-- what's coming, without leaking what it is -->
		<div v-if="teaser" class="hint-tile is-next">
			<span class="hint-next">{{ teaser }}</span>
		</div>

	</div>

</div>

</template>

<script>

/*
	The hint track. The server reveals one already-ordered { label, value } hint
	on every even guess (weak -> strong); they ACCUMULATE on screen in arrival
	order — we render game.hints verbatim and never re-sort. Below them a muted
	teaser counts down to the next hint ("Next hint in X guesses") using the
	server's schedule + hint count, without revealing what that hint is.
*/

export default {

	computed: {

		hints: function() {

			return this.$store.getters['game/hints']

		},

		today: function() {

			return this.$store.getters['game/today']

		},

		guessesUsed: function() {

			return this.$store.getters['game/guessesUsed']

		},

		teaser: function() {

			var today = this.today

			if (!today) return ''

			var schedule = today.hint_schedule || []
			var count = today.hint_count || 0

			// the next hint is the one after those already revealed
			var nextIndex = this.hints.length

			if (nextIndex >= count || nextIndex >= schedule.length) return ''

			var remaining = schedule[nextIndex] - this.guessesUsed

			if (remaining <= 0) return ''

			return 'Next hint in ' + remaining + (remaining === 1 ? ' guess' : ' guesses')

		}

	}

}

</script>

<style scoped>

.hints {
	border-top: 1px solid var(--hairline);
	padding-top: 14px;
}

.hints-head {
	font-family: var(--font-mono);
	font-size: 10px;
	letter-spacing: 0.16em;
	text-transform: uppercase;
	color: var(--muted);
	margin-bottom: 10px;
}

.hints-list,
.hints-revealed {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.hint-tile {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 13px;
	background: #eef1f6;
	border: 1px solid #dde3ee;
	border-radius: 7px;
}

/* the upcoming-hint teaser is quieter than a real hint */
.hint-tile.is-next {
	background: transparent;
	border-color: var(--hairline);
	justify-content: center;
}

.hint-label {
	font-family: var(--font-mono);
	font-size: 10.5px;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	color: var(--accent);
	flex: none;
}

.hint-value {
	font-family: var(--font-body);
	font-size: 14px;
	font-weight: 500;
	color: var(--ink);
	text-align: right;
}

.hint-next {
	font-family: var(--font-mono);
	font-size: 10.5px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--muted);
}

.hint-enter-active {
	animation: hint-settle 360ms ease both;
}

@keyframes hint-settle {
	from { opacity: 0; transform: translateY(-4px) scale(0.98); }
	to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {

	.hint-enter-active {
		animation: none;
	}

}

</style>
